import { Node, mergeAttributes } from "@tiptap/core";

// Custom SlideNotes extension
export const SlideNotes = Node.create({
  name: "slideNotes",
  group: "block",
  content: "block+",

  defining: true,

  selectable: true,

  parseHTML() {
    return [
      {
        tag: "div.slide-deck-notes",
      },
    ];
  },

  addAttributes() {
    return {
      class: {
        default: "slide-deck-notes",
      },
      blockId: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-block-id"),
        renderHTML: (attributes) => {
          return { "data-block-id": attributes.blockId };
        },
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(
        {
          class: "slide-deck-notes",
          "data-content-type": "slideNotes",
          "data-block-id": HTMLAttributes.blockId,
        },
        HTMLAttributes
      ),
      0,
    ];
  },
});
